export function hasNotificationsPermission(user) {
  return user?.permissions?.notifications !== false;
}

export function hasClassesPermission(user) {
  return user?.permissions?.classes === true;
}
